// Должен соответствовать projectName
export const UNIQUE_CONFIG_KEY = 'add-form-frontend';

export const PAYMENT_INIT_SOURCE = 'publishObject';
